import { render, staticRenderFns } from "./metiers-block.vue?vue&type=template&id=05fed23a&"
import script from "./metiers-block.vue?vue&type=script&lang=js&"
export * from "./metiers-block.vue?vue&type=script&lang=js&"
import style0 from "./metiers-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports